import FreeTextSearchInput from "./FreeTextSearchInput";

export default FreeTextSearchInput;
